module.exports = __webpack_public_path__ + "static/img/advantage-icon4.c8b4330d.png";